import React from 'react';
import Icon from '../../atoms/Icon';
import './DashboardHeader.css';

interface DashboardHeaderProps {
  title: string;
  onToggleSidebar: () => void;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  title, 
  onToggleSidebar,
  onRefresh,
  isRefreshing = false
}) => {
  return (
    <header className="dashboard-header">
      <button
        className="sidebar-toggle"
        onClick={onToggleSidebar}
      >
        <Icon type="menu" size="medium" />
      </button>

      <div className="header-content">
        <h1>{title}</h1>
        <div className="header-actions">
          {onRefresh && (
            <button
              className="refresh-button"
              onClick={onRefresh}
              disabled={isRefreshing}
              title="Refresh data"
            >
              <Icon type="notification" size="small" />
              {isRefreshing ? 'Refreshing...' : 'Refresh'}
            </button>
          )}
          <div className="user-profile">
            <img src="/images/logo/tfr.avif" alt="Admin" className="profile-avatar" />
            <span>Admin</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
